import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  quote: string;
  rating?: number;
}
export function TestimonialCard({
  name,
  location,
  quote,
  rating = 5
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-amber-100 hover:shadow-lg transition-shadow duration-300" data-id="element-218">
      <div className="flex gap-1 mb-4 text-amber-400" data-id="element-219">
        {[...Array(rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-220" />)}
      </div>
      <p className="text-gray-700 italic mb-6 font-serif text-lg leading-relaxed" data-id="element-221">
        "{quote}"
      </p>
      <div className="flex items-center gap-3" data-id="element-222">
        <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 font-bold text-lg" data-id="element-223">
          {name.charAt(0)}
        </div>
        <div data-id="element-224">
          <p className="font-semibold text-gray-900" data-id="element-225">{name}</p>
          <p className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-226">
            {location}
          </p>
        </div>
      </div>
    </div>;
}